/* Swindo — automatisk gåva.
 *
 * Löftet står tryckt på produktsidan ("Gratis Swindo FastDry 30×30" på 1-pack),
 * så korgen måste hålla det utan att kunden gör något. Reglerna:
 *
 *   utlösaren i korgen  →  exakt 1 gåva i korgen
 *   utlösaren borta     →  gåvan bort
 *
 * Gåvan är en egen produkt på 0 kr (inget rabattkodsregelverk inblandat), så
 * den syns som en rad i ordern och går att plocka och skicka som vilken vara
 * som helst.
 *
 * Två saker den ALDRIG får göra: skapa en slinga, eller stå i vägen för ett
 * köp. Därför en återinträdesspärr, och därför sväljs varje fel tyst — går
 * gåvan fel ska korgen ändå fungera.
 */
(function () {
  var K = window.SwindoGave;
  if (!K || !K.gave || !K.utlosare || !K.utlosare.length) return;

  var GAVA = String(K.gave);
  var UTLOSARE = K.utlosare.map(String);
  var arbetar = false;

  function antal(korg, id) {
    var n = 0;
    for (var i = 0; i < korg.items.length; i++) {
      if (String(korg.items[i].variant_id) === String(id)) n += korg.items[i].quantity;
    }
    return n;
  }

  function onskatAntal(korg) {
    for (var i = 0; i < UTLOSARE.length; i++) {
      if (antal(korg, UTLOSARE[i]) > 0) return 1;
    }
    return 0;
  }

  /* Returnerar korgens nya tillstånd om något ändrades, annars null. */
  async function stam(sektioner) {
    var korg = await (await fetch('/cart.js', { cache: 'no-store' })).json();
    var vill = onskatAntal(korg);
    var har = antal(korg, GAVA);
    if (vill === har) return null;

    var uppdatering = {};
    uppdatering[GAVA] = vill;
    var kropp = { updates: uppdatering };
    if (sektioner) {
      kropp.sections = sektioner;
      kropp.sections_url = window.location.pathname;
    }
    var svar = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(kropp)
    });
    if (!svar.ok) return null;
    return await svar.json();
  }

  function lada() {
    return document.querySelector('cart-drawer');
  }

  /* Byter ut lådans innehåll utan att öppna den — renderContents() anropar
   * open(), vilket är rätt efter ett klick men fel vid sidladdning. */
  function malaOm(tillstand) {
    var el = document.getElementById('CartDrawer') ||
             document.querySelector('#shopify-section-cart-drawer');
    var html = tillstand && tillstand.sections && tillstand.sections['cart-drawer'];
    if (!el || !html) return;
    var ny = new DOMParser().parseFromString(html, 'text/html')
      .querySelector('#CartDrawer, #shopify-section-cart-drawer');
    if (ny) el.innerHTML = ny.innerHTML;
  }

  async function stamTyst() {
    if (arbetar) return;
    arbetar = true;
    try {
      var t = await stam(['cart-drawer']);
      if (t) malaOm(t);
    } catch (e) {
      /* korgen ska fungera även när gåvan inte gör det */
    } finally {
      arbetar = false;
    }
  }

  /* Efter kundens egen ändring: stäm av och låt lådan rita om sig själv med
   * appens egen väg, så att räknare, fraktbar och upsell följer med. */
  async function stamSynligt() {
    if (arbetar) return;
    arbetar = true;
    try {
      var l = lada();
      var sektioner = l && l.getSectionsToRender
        ? l.getSectionsToRender().map(function (s) { return s.id; })
        : ['cart-drawer'];
      var t = await stam(sektioner);
      if (t && l && l.renderContents) l.renderContents(t);
      else if (t) malaOm(t);
    } catch (e) {
      /* tyst */
    } finally {
      arbetar = false;
    }
  }

  var KORG_SKRIV = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var origFetch = window.fetch;
  window.fetch = function (indata, init) {
    var svar = origFetch.apply(this, arguments);
    try {
      var url = typeof indata === 'string' ? indata : (indata && indata.url) || '';
      if (!arbetar && KORG_SKRIV.test(url)) {
        svar.then(function (r) {
          if (r && r.ok) setTimeout(stamSynligt, 60);
        }).catch(function () {});
      }
    } catch (e) {
      /* aldrig i vägen för anropet */
    }
    return svar;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stamTyst);
  } else {
    stamTyst();
  }
})();
